"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.lineForPosition = function (pos, lines) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var end = arguments.length > 3 ? arguments[3] : undefined;

  if (pos === 0 || lines.length === 0 || pos < lines[0]) {
    return 0;
  }

  if (typeof end === 'undefined') {
    end = lines.length;
  }

  var target = Math.floor((end - start) / 2) + start;

  if (pos >= lines[target] && !lines[target + 1]) {
    return target + 1;
  }

  var nextLinePos = lines[Math.min(target + 1, lines.length)];

  if (pos === lines[target] - 1) {
    return target;
  }

  if (pos >= lines[target] && pos <= nextLinePos) {
    if (pos === nextLinePos) {
      return target + 2;
    }

    return target + 1;
  }

  if (pos > lines[target]) {
    return exports.lineForPosition(pos, lines, target + 1, end);
  } else {
    return exports.lineForPosition(pos, lines, start, target - 1);
  }
};